import { WhatsAppNotificationService } from '@gtpl/shared-services/notification-management';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { AssetAssignmentTransaction } from '../asset-assignment/entity/asset-assignment-transaction.entity';
import { AssetAssignmentRepository } from '../asset-assignment/repository/asset-assignment.repository';
import { AssetLocationTransaction } from '../asset-location-mapping/entity/asset-location-transaction.entity';
import { AssetLocationMappingRepository } from '../asset-location-mapping/repository/asset-location-mapping.repository';
import { LocationRepository } from '../locations/dto/location-repository';
import { AssetsAdapter } from './dto/open-assets-adpater';
import { AssetsRepository } from './dto/opens-assets-repository';
import { Assets } from './open-assets-entity';
import { AssetsController } from './open-assets.controller';
import { AssetsService } from './open-assets.service';
import { AssetService } from './asset-service.entity';
import { AssetServiceAdapater } from './dto/asset-service.adapter';
import { AssetServiceRepository } from './dto/asset-service.repository';
import { AssetServiceChecklist } from './asset-service-checklist.entity';
import { AssetServiceHelper } from './assets-service-helper';
import { AssetTransaction } from './asset-transaction-entity';
import { AssetTransactionAdapter } from './dto/asset-transaction-adapter';
import { WhatsappBroadCastService } from '@gtpl/shared-services/whatsapp-broad-cast';
import { AssetMaintainanceService } from '../asset-maintainance/asset-maintainance.service';
import { AssetMaintainanceRepository } from '../asset-maintainance/repository/asset-maintainance.repository';
import { AssetMaintainanceAdapter } from '../asset-maintainance/asset-maintainance.adapter';
import { AssetMaintainanceTrasactionsRepository } from '../asset-maintainance/repository/asset-maintainance-transactions.repository';
import { ChecklistRepository } from './dto/checklist-repository';

@Module({
  imports: [
    TypeOrmModule.forFeature([Assets,AssetLocationMappingRepository,AssetLocationTransaction,AssetAssignmentRepository,AssetAssignmentTransaction, LocationRepository,AssetService,AssetServiceRepository,AssetServiceChecklist,AssetTransaction,AssetMaintainanceRepository,AssetMaintainanceTrasactionsRepository,ChecklistRepository]),
  ],
  providers: [AssetsService,AssetsAdapter,ApplicationExceptionHandler,WhatsAppNotificationService,AssetServiceAdapater,AssetServiceHelper,AssetTransactionAdapter,WhatsappBroadCastService,AssetMaintainanceService,AssetMaintainanceAdapter],
  controllers: [AssetsController],
  exports:[TypeOrmModule],
})
export class AssetsModule {}
